import React from 'react';
import { PARTICIPANT_WELLNESS_PAGE_SIZE } from '../../constants';
import type { IWellnessInviteData } from '../../interfaces';
import { WellnessDashboard } from '../WellnessDashboard';

export interface IWellnessTabProps {
  invites: IWellnessInviteData[];
  totalCount: number;
  loading: boolean;
  page: number;
  onPageChange: (page: number) => void;
  onRefresh: () => void;
}

/** Thin adapter: paging shape owned here, invite flow owned by WellnessDashboard. */
export const WellnessTab = ({
  invites,
  totalCount,
  loading,
  page,
  onPageChange,
  onRefresh,
}: IWellnessTabProps) => {
  return (
    <WellnessDashboard
      invites={invites}
      totalCount={totalCount}
      loading={loading}
      page={page}
      pageSize={PARTICIPANT_WELLNESS_PAGE_SIZE}
      onPageChange={onPageChange}
      onRefresh={onRefresh}
    />
  );
};
